import { observer } from 'mobx-react-lite'
import { useInjection } from '@core/providers/inversify-react.provider'
import { Button } from '@ui-kit/button.component'
import { NotFoundPagePresenter } from './not-found-page.presenter'

export const NotFoundPageComponent = observer(() => {
  const presenter: NotFoundPagePresenter = useInjection(NotFoundPagePresenter)
  const vm = presenter.viewModel

  return (
    <div className="flex min-h-full flex-col items-center justify-center px-4 py-16 text-center">
      <h1 className="text-2xl font-bold text-shell-ink">{vm.title}</h1>
      <p className="mt-2 text-sm text-shell-ink-secondary">{vm.body}</p>
      <Button tone="primary" className="mt-6" onClick={() => presenter.goHome()}>
        {vm.goHomeLabel}
      </Button>
    </div>
  )
})
